import { useState } from 'react';

import { apiLSNext } from '../api';

import { UseGetTransactionInfo, TransactionInfo } from './types';
import { TransactionStatus } from '../constants';

const useGetTransactionInfo: UseGetTransactionInfo = ({ transactionId, setError }) => {
  const [transaction, setTransaction] =  useState<TransactionInfo | undefined>(undefined);

  const handleGetTransaction = async () => {
    try {
      const response = await apiLSNext.get(`/api/v1/deposit/${transactionId}`);

      const obj = response.data?.data;
      let objParams = {};

      if (obj !== undefined && obj !== null) {
        objParams = typeof obj === 'string' ? JSON.parse(obj) : obj;
      }

      const data = { ...response.data, data: objParams };

      setTransaction(data);

      if (!data.pageUrl) {
        return TransactionStatus.Unavailable
      }

      return TransactionStatus.Success;
    } catch (e) {
      setError(String(e));

      return TransactionStatus.Error;
    }
  };

  return { onGetTransaction: handleGetTransaction, transaction };
};

export default useGetTransactionInfo;
